<!--
 * @Author: your name
 * @Date: 2021-08-09 17:24:51
 * @LastEditTime: 2021-08-17 14:44:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \malu_pc\malu_pc\src\pages\guanyuwomen.vue
-->
<template>
  <div class="wrapper">
   <el-image
     class="top"
      style="width: 100%;"
      src="https://show.malukeji.com/demo/page/static/img/01.png"
      fit="contain"
      alt="码路科技"
    ></el-image> 
    <div style="text-align:center ;">
      <el-image
            style="width: 300px"
            src="/static/wexrwm.png"
            fit="contain"
          ></el-image>
    </div>
    <div class="about_us">
      <div class="about_us_contcat">
        <div class="us_phone" @click="copyContentH5('13393210831')" >
           <span ref="phone" style="text-decoration: underline"
            ><i class="el-icon-phone-outline"></i>13393210831</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "gunayuwomen",
  data() {
    return {
     
    };
  },
  mounted() {
   
  },
  methods: {
     copyContentH5(content) {
    var copyDom = document.createElement('div');
    copyDom.innerText=content;
    copyDom.style.position='absolute';
    copyDom.style.top='0px';
    copyDom.style.right='-9999px';
    document.body.appendChild(copyDom);
    //创建选中范围
    var range = document.createRange();
    range.selectNode(copyDom);
    //移除剪切板中内容
    window.getSelection().removeAllRanges();
    //添加新的内容到剪切板
    window.getSelection().addRange(range);
    //复制
    var successful = document.execCommand('copy');
    copyDom.parentNode.removeChild(copyDom);
    try{
        var msg = successful ? "successful" : "failed";
        console.log('Copy command was : ' + msg);
         this.$message({
          message: '复制成功',
          type: 'success',
          offset:450
        });
    } catch(err){
        console.log('Oops , unable to copy!');
    }
}
  },
};
</script>

<style lang="scss">
@import "../assets/common.scss";
</style>


// WEBPACK FOOTER //
// src/pages/guanyuwomen.vue